// extracted by mini-css-extract-plugin
module.exports = {"card":"_1f29uB","image":"_38cQaB","title":"_3Y_E8p","subTitle":"_1mWMti","shine-lines":"_1H5v75"};